const HeaderReq = (token, extraParams = {}) => {
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Accept-Language": "fa-IR",
        chHostName: process.env.REACT_APP_CHHOSTNAME,
        ...extraParams,
      },
    };
  } else {
    return {
      headers: {
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
        Expires: "0",
        "Accept-Language": "fa-IR",
        chHostName: process.env.REACT_APP_CHHOSTNAME,
        ...extraParams,
      },
    };
  }
};
export default HeaderReq;
